"use strict"

import React from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../components/shared_components_registration"
const registration = {
  add_another_plot: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.add.another.plot" }) : "Add Another Plot",
}

export default function AddAnotherPlotBtn({ intl, updateGraphs }) {
  return (
    <Button
      title={registration.add_another_plot(intl)}
      variant={"outline-primary"}
      onClick={(ev) => {
        ev.preventDefault()
        updateGraphs((graphs) => [...graphs, null])
      }}
    >
      <span className="fa fa-plus-circle" />
      &nbsp;
      {registration.add_another_plot(intl)}
    </Button>
  )
}
